export default __webpack_public_path__ + "static/media/news-1.70da2850.jpg";